import React from 'react'
import Layout from '../components/Layout'
import Banner from '../components/Banner'
import SEO from '../components/Seo' 

export default function Page() {

    return (
        <>
            <SEO
                title="How to Background Search Anyone Online"
                description="Get instant access to public records for anyone. Simply enter a name and state and get instant results."
            />
            <Layout>
                <div className="mainContainer">
                    <div className="container-fluid s2">
                        <div className="container">
                            <div className="row">
                                <h1 className="center">How To Background Search Anyone</h1>
                                <div className="container center">
                                    <p className="h2">Background Search Tips</p>
                                    <hr />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <h2>How To: Background Check Someone</h2>
                                    <p>Millions of people have used Instant Checkmate’s background check reports to learn more information about almost anyone. Here’s how you can perform your own search.</p>
                                    <h3>1) Gather Their Information</h3>
                                    <p>Start by writing down as much information as you can about the person you want to background search. This can include:</p>
                                    <ul>
                                        <li>First name</li>
                                        <li>Last name</li>
                                        <li>Age</li>
                                        <li>Birthdate</li>
                                        <li>Cities they’ve lived in</li>
                                    </ul>
                                    <p>If the person you’re searching for has a common name, such as “Thomas Smith,” then you will likely get many results by searching just their name. Additional details can help find the report for the exact person you want to find.</p>
                                    <h3>2) Search For Their Name</h3>
                                    <p>Enter the information you have into the search box and click on the search button. You will be brought to the search results page, which typically lists many possible reports.</p>
                                    <p>Each item on the search results page includes identifying information, such as age and previous addresses. Find the report that matches the information you know. Instant Checkmate members can pull as many Standard Reports as they want, so you can check multiple reports if you’re not sure.</p>
                                    <h3>3) Pull The Correct Report</h3>
                                    <p>Pulling the correct report is as simple as clicking on the “View Report” button. Once you have identified the correct report, you have the option of saving it as a PDF. This requires a small, one-time fee to unlock PDF report access. After you unlock PDF report access, you can download the PDF version of as many reports as you want.</p>
                                    <p><strong>How To Find Someone With Just An Email Address Or Phone Number</strong></p>
                                    <p>Do you only have a single piece of information about someone? It still might be possible to pull someone's background report, even if all you have is a phone number or email address.</p>
                                    <p>To find someone with their US-based phone number, enter it into the phone search box. It may uncover a report that includes the name, carrier, and even address of the person who currently owns the phone number.</p>
                                    <p>To find someone with their email address, enter their email address in the search field on the Instant Checkmate account dashboard. We will cross-check that email address to see if it connects with any name in our database.</p>
                                    <p><strong>What Kind Of Data Is Contained In A Background Check Report?</strong></p>
                                    <p>A few different factors determine the type and amount of data we offer: the specific information contained in a person's public records, laws pertaining to public records, and whether or not somebody has decided to opt out of Instant Checkmate.</p>
                                    <p>However, Instant Checkmate Standard Reports can contain a broad variety of data, including:</p>
                                    <ul>
                                        <li>First and last name</li>
                                        <li>Birthdate and age</li>
                                        <li>Phone numbers</li>
                                        <li>Email addresses</li>
                                        <li>Possible related persons</li>
                                        <li>Location history</li>
                                        <li>Sex offenders who live around a particular address</li>
                                        <li>Social media profiles</li>
                                        <li>Criminal records</li>
                                        <li>FAA and DEA licenses</li>
                                    </ul>
                                    <p>Optionally, you can upgrade to a Premium Report for an additional fee. When available, information in a Premium Report may include:</p>
                                    <ul>
                                        <li>Corporate affiliations</li>
                                        <li>Businesses owned</li>
                                        <li>Properties owned</li>
                                        <li>Tax liens</li>
                                        <li>Professional licenses</li>
                                        <li>Hunting/fishing permits</li>
                                        <li>Weapons permits</li>
                                        <li>Foreclosures</li>
                                        <li>Neighbors</li>
                                        <li>Business associates</li>
                                        <li>And more.</li>
                                    </ul>
                                    <p>Start your search today by entering any name in the search bar at the top of this page!</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container s1">
                        <div className="row">
                            <div className="container center">
                                <div className="embed-responsive embed-responsive-16by9">
                                    <iframe title="unique" className="embed-responsive-item" src="https://www.youtube.com/embed/hpGTpJSDNhU?rel=0&amp;showinfo=0"></iframe>
                                </div>
                            </div>
                            <p>Learn how to find public records for anyone (including yourself) using Instant Checkmate!</p>
                            <p className="center"><span className="label label-success">Difficulty: Easy</span>
                                <span className="label label-info">Estimated Time: 5-8 minutess</span></p>
                        </div>
                    </div>

                </div>
                <Banner />
            </Layout>
        </>
    )
}
